import React from 'react'
import { Button } from '../../../../common'
import { FiCopy } from 'react-icons/fi'
import { motion } from 'framer-motion'

interface ResourceItemProps {
  label: string
  value: string
  onCopy?: () => void
  showCopyButton?: boolean
  isCopied?: boolean
}

const ResourceItem: React.FC<ResourceItemProps> = ({
  label,
  value,
  onCopy,
  showCopyButton = true,
  isCopied = false
}) => {

  const handleCopy = () => {
    console.log('Copying:', value);
    if (onCopy) {
      onCopy()
    } else {
      navigator.clipboard.writeText(value)
    }
  }

  return (
    <div className="resource-field">
      <div className="resource-label">{label}</div>
      <motion.div
        className={`resource-item ${isCopied ? 'copied' : ''}`}
        onClick={handleCopy}
      >
        <div className="resource-value truncate">{value}</div>
        {showCopyButton && (
          <div className="copy-section">
            <motion.small
              className="copied-text"
              initial={{ opacity: 0, x: 10 }}
              animate={isCopied ? { opacity: 1, x: 0 } : { opacity: 0, x: 10 }}
              transition={{ duration: 0.4 }}
            >
              {isCopied && 'Kopierad'}
            </motion.small>
            <Button className="copy-button sm">
              <motion.div
                animate={isCopied ? { rotate: [0, 10, 0] } : { rotate: 0 }}
                transition={{ duration: 0.3 }}
              >
                <FiCopy />
              </motion.div>
            </Button>
          </div>
        )}
      </motion.div>
    </div>
  )
}

export default ResourceItem
